import { Obstruction } from '../obstruction.class';
import islandAssetMap from '../../data/island-asset.map.json';
import { IslandAssetData, IslandAssetProperties } from '../types';

/**
 * Calculates island name based on type and size
 * @param island Island to calculate the base size for
 * @param skuData [string, IslandAssetData]
 * @returns string
 */
export const getIslandDescriptionCfn = (island: Obstruction, skuData: [string, IslandAssetProperties]): string => {
	const assetMap: Record<string, IslandAssetData> = islandAssetMap;
	const width = island.size.width ?? 0;
	let key: string = null;

	for (const size in assetMap.STANDARD) {
		if (size) {
			key = size as string;
			const assetData = assetMap.STANDARD[size]
			if (width > assetData.min && width <= assetData.max) break;
			else key = '22+';
		}
	}

	let heightType = '';
	if (island.sku.charAt(5) === 'K') heightType = 'Asado Stand';
	else if (island.sku.charAt(7) === 'C') heightType = 'Corner Stand';
	else if (island.sku.charAt(5) === 'P') heightType = 'Pizza Stand';
	else {
		heightType = island.size.height >= 36.75
			? `${key}ft Bar Island`
			: island.size.height >= 27.5
				? `${key}ft Grill Island`
				: `${key}ft Smoker Stand`;
	}

	return `${heightType} | Base Length ${island.size.width}" | Island Height ${island.size.height}"`;
};
